export default "__VITE_ASSET__946d4605__"